import { reduce } from "lodash";
import { getMappedPath } from "@Client/@Composables/application-standalone/validations/getMappedPath";
export const getValidationRulesFromMap = (isVisibleFromFillOut, GET_SCHEMA_RULES_BY_PATH, rules, prefix = "", indexes = {}) => {
  return reduce(rules, (acc, extraRules, path) => {
    const mappedPath = getMappedPath(path, prefix);
    if (mappedPath && isVisibleFromFillOut(mappedPath)) acc[path] = GET_SCHEMA_RULES_BY_PATH.value(mappedPath, extraRules, indexes);
    return acc;
  }, {});
};